import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";


import {
  GET_EMAIL_TEMPLATES,
  SG_GET_EMAIL_TEMPLATES,
  EMAIL_TEMPLATE_SELECT,
  SG_EMAIL_TEMPLATE_SELECT,
  SG_COPY_EMAIL_TEMPLATE,
  COPY_EMAIL_TEMPLATE,
  DELETE_EMAIL_TEMPLATE,
  SG_DELETE_EMAIL_TEMPLATE,
  FETCH_EMAIL_TEMPLATE,
  SG_FETCH_EMAIL_TEMPLATE,
  EDIT_EMAIL_TEMPLATE,
  SG_EDIT_EMAIL_TEMPLATE,
  ADD_EMAIL_TEMPLATE,
  SG_ADD_EMAIL_TEMPLATE,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMAIL_TEMPLATES, action.payload);
    // console.log(json.data)
    yield put({ type: GET_EMAIL_TEMPLATES, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeEvery(SG_GET_EMAIL_TEMPLATES, loadmethods);
}

function* selectmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMAIL_TEMPLATE_SELECT, action.payload);
    // console.log(json.data)
    yield put({ type: EMAIL_TEMPLATE_SELECT, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodSelect() {
  yield takeEvery(SG_EMAIL_TEMPLATE_SELECT, selectmethods);
}

function* duplicatemethods(action) {
  try {
    const json = yield call(api.COPY_EMAIL_TEMPLATE, action.payload);
    yield put({ type: COPY_EMAIL_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDuplicate() {
  yield takeLatest(SG_COPY_EMAIL_TEMPLATE, duplicatemethods);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_EMAIL_TEMPLATE, action.payload);
    yield put({ type: FETCH_EMAIL_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_EMAIL_TEMPLATE, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_EMAIL_TEMPLATE, action.payload);
    yield put({ type: EDIT_EMAIL_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_EMAIL_TEMPLATE, updatemethods);
}

function* addmethods(action) {
  // RESET_ADD_ACTIVE_PAGE_EMAIL_TEMPLATE
  try {
    const json = yield call(api.ADD_EMAIL_TEMPLATE, action.payload);
    yield put({ type: ADD_EMAIL_TEMPLATE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_EMAIL_TEMPLATE, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_EMAIL_TEMPLATE, action.payload);
    yield put({ type: DELETE_EMAIL_TEMPLATE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_EMAIL_TEMPLATE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodSelect(),
    methodDuplicate(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
